import Node from './Node';
import ViewportMixin from './mixins/ViewportMixin';
import mixin from '../privates/utils/mixin';
import * as members from '../privates/privateMembers';

/**
 * @class Anchor
 * @summary <a href="https://www.wix.com/support/html5/article/about-anchors" target="_blank">Anchors</a>
 *  are invisible position markers which you can place anywhere on your site.
 *  They are a useful way to direct users to important sections.
 * @mixes $w.Node
 * @mixes $w.ViewportMixin
 * @memberof $w
 * @queryable
 * @viewername wysiwyg.common.components.anchor.viewer.Anchor
 * @definitionId wysiwyg.common.components.anchor.viewer.Anchor
 * @tagname Anchor
 */
class Anchor extends Node {
    /**
     * @member name
     * @label property
     * @syntax
     * get name(): string
     * @summary Gets the name of an anchor.
     * @description
     *  An anchor's `name` is used as a label for the anchor. The value of the `name`
     *  property appears in [anchor menus](https://support.wix.com/en/article/anchor-menu).
     *
     *  An anchor's `name` is set in the Editor using the Anchor Settings panel.
     *  ![Anchor Settings](images/anchor_settings.png "Anchor Settings")
     * @snippet [Anchor-name.es6=Get an anchor's name]
     * @type {external:String}
     * @see [id](#id)
     * @memberof $w.Anchor
     * @instance
     * @readonly
     */
    get name() {
        const RMI = members._RMI.get(this);
        const compId = members._compId.get(this);
        return RMI.getData(compId).name;
    }

    toJSON() {
        const {id, type, global, rendered, name} = this;
        return {id, type, global, rendered, name};
    }
}

mixin(Anchor.prototype, ViewportMixin.prototype);

export default Anchor;
